import { render, staticRenderFns } from "./UpgradeBoxList.vue?vue&type=template&id=5c50d8fc&scoped=true&"
import script from "./UpgradeBoxList.vue?vue&type=script&lang=js&"
export * from "./UpgradeBoxList.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeBoxList.vue?vue&type=style&index=0&id=5c50d8fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c50d8fc",
  null
  
)

export default component.exports